import { useSelector } from "react-redux";
import { useAppDispatch } from "../../redux/store";
import { setItem } from "../../redux/Reducers/createPostReducer";
import DropDown from "../DropDown";
import Section from "./Section";
import { T } from "react-translator-component";

interface Props {
  categories: any[]
}

export default function SelectCategory({ categories }: Props) {
  const dispatch = useAppDispatch();

  const category = useSelector((state: any) => state.createPost.values.category);
  const error = useSelector((state: any) => state.createPost.errors.category);

  return (
    <Section
      title={`${T("post_category")}${T("required")}`}
      body={(
        <DropDown
          style={{ marginTop: -10 }}
          title={T("post_category")}
          star
          options={categories}
          value={category}
          error={error !== ""}
          errorMessage={error}
          onChange={(e) => dispatch(setItem({key: 'category', value: String(e.target.value)}))}
        />
      )}
      style={{ marginTop: 0 }}
    />
  )
}
